import { TaskT } from 'ui-io/task-io/task-t'
import { TaskInboxViewT } from '../../../pages/tasks/inbox-views'

const getNextView = (task: TaskT): TaskInboxViewT => {
  const tabToStateMapper: { [key: string]: TaskInboxViewT } = {
    PENDING: 'Pending',
    CLOSED: 'Completed',
    APPROVED: 'Approved',
  }
  return task.currentState ? tabToStateMapper[task.currentState] : tabToStateMapper.IN_EDITING
}

export default getNextView
